import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/store";

import LandingPage from "./screens/LandingPage/LandingPage.jsx";
import LoginScreen from "./screens/LoginScreen/LoginScreen.jsx";
import AppShell from "./components/layout/AppShell";
import { DmsPreviewProvider } from "./components/dms/DmsPreviewProvider";
import DmsPreviewPanel       from "./components/dms/DmsPreviewPanel";

// ✨ Design system — page↔form event bus
import { ToolbarBusProvider, ToastProvider } from "./ds";
// 🛡️ Self-healing boundary — converts any silent blank page into a
//    one-shot auto-reload (chunk errors) or a "Reset & reload" card.
import RootErrorBoundary from "./components/RootErrorBoundary";

/* ──────────────────────────────────────────────────────────────
   PersistGate fallback
   ──────────────────────────────────────────────────────────────
   `loading={null}` used to render a blank white page whenever
   rehydration hung. A visible spinner makes the state obvious:
     • spinner forever  → persist / migration problem
     • blank white page → app genuinely failed to mount
   ────────────────────────────────────────────────────────────── */
const PersistLoading = () => (
  <div className="ds-loading-overlay">
    <div className="d-flex flex-column align-items-center">
      <div className="spinner-border text-primary" />
      <div
        className="mt-2"
        style={{ color: "var(--ds-text-muted)", fontSize: "var(--ds-fs-sm)" }}
      >
        Restoring session…
      </div>
    </div>
  </div>
);

const App = () => (
  <RootErrorBoundary>
    <Provider store={store}>
      <PersistGate loading={<PersistLoading />} persistor={persistor}>
        <Router>
          <ToolbarBusProvider>
            <ToastProvider>
              <Routes>
                <Route path="/"          element={<LandingPage />} />
                <Route path="/login"     element={<LoginScreen />} />
                <Route path="/dashboard" element={<AppShell />}    />
              </Routes>
            </ToastProvider>
          </ToolbarBusProvider>
        </Router>
      </PersistGate>
    </Provider>
  </RootErrorBoundary>
);

export default App;
